<template>
  <label
    ref="compContainer"
    class="comp-container comp-container__input"
    :class="{
      'is-filled': inputValue !== null || inputValue === '' || compositing,
      'has-error': hasError,
    }"
    :for="$attrs.id"
  >
    <slot name="icon"></slot>
    <div class="comp-main POS-r">
      <template>
        <span class="label POS-a">{{ computedLabel }}</span>
      </template>
      <input
        :type="type"
        :inputmode="inputmode"
        v-model="inputValue"
        v-on:change="updateValue($event.target.value)"
        v-on:focus="handleFocus()"
        v-on:blur="handleBlur()"
        v-on:invalid="handleInvalid()"
        @input="handleInput"
        v-on:compositionstart="compositing = true"
        v-on:compositionupdate="compositing = true"
        v-on:compositionend="compositing = false"
        v-bind="$attrs"
        @keypress="$emit('keypress', $event)"
      >
    </div>
    <span
      v-if="this.clearable && this.value"
      v-on:click="updateValue(null)"
      class="material-icons-round C-grey"
    >cancel</span>
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: null,
    label: {
      default: null,
    },
    placeholder: {
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    inputmode: {
      type: String,
      default: 'text',
    },
    maxBytes: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      inputValue: null,
      compositing: false,
    };
  },
  mounted() {
    this.inputValue = this.value;
  },
  computed: {
    computedLabel() {
      if (this.inputValue) {
        return this.label || '';
      }
      return this.placeholder || this.label || '';
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    handleFocus() {
      this.$refs.compContainer.classList.add('is-focused');
    },
    handleBlur() {
      if (this.inputValue === '') {
        this.inputValue = null;
      }
      this.$refs.compContainer.classList.remove('is-focused');
    },
    handleInvalid() {
      this.$refs.compContainer.classList.add('has-error');
    },
    handleInput(event) {
      if (!this.maxBytes) return;
      const val = event.target.value;
      if (this.countBytes(val) <= this.maxBytes * 3) return;
      const slicedText = this.sliceBytes(val, this.maxBytes * 3);
      this.inputValue = slicedText;
    },
    countBytes(text) {
      return new TextEncoder().encode(text).length;
    },
    sliceBytes(text, maxBytes) {
    // encode 後去 slice
      const unit8 = new TextEncoder()
        .encode(text)
        .slice(0, maxBytes);

      // slice 完再 decode 反解回來
      const section = new TextDecoder('utf-8')
        .decode(unit8)
        .replace(/\uFFFD/g, ''); // 去除亂碼

      return section;
    },
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal;
    },
  },
};
</script>

<style lang="sass" scoped>
.comp-container
  min-height: 54px
  display: flex
  align-items: center
  padding: $size-xs $size-m
  box-shadow: inset 0 0 0 0 $color-light-grey

  border-radius: $size-s

  background-color: $color-light

  transition: box-shadow $time-fast $cb

  &:hover
    box-shadow: inset 0 0 0 1px transparentize($color-light-grey, .5)

  &.is-focused
    box-shadow: inset 0 0 0 2px $color-light-grey

  &.has-error
    box-shadow: inset 0 0 0 1px $color-notice

    background-color: white

    .icon
      color: transparentize($color-notice, .5)

      animation-duration: 1s
      animation-name: shake

  &.is-filled
    .label
      color: $color-grey

      transform: translateY(-100%) scale(.75)

    input
      padding-top: 17px

.comp-main
  flex-grow: 1
  display: flex
  flex-direction: column

.icon
  transition: transform $time-fast $cb

.label
  left: 0
  top: 50%

  color: $color-grey

  transform: translateY(-50%)
  transform-origin: center left
  transition: color $time-fast $cb, font-size $time-fast $cb, transform $time-fast $cb, top $time-fast $cb

  pointer-events: none

input
  display: block
  width: 100%
  padding: 0

  border: none
  border-radius: $size-s

  background-color: transparent

  color: $color-dark

  appearance: none

  &:focus
    outline: none

@keyframes shake
  from,
  to
    transform: translate3d(0, 0, 0)

  10%,
  30%,
  50%,
  70%,
  90%
    transform: translate3d(-10%, 0, 0)

  20%,
  40%,
  60%,
  80%
    transform: translate3d(10%, 0, 0)
</style>
